<template>
  <div class="block-main-header">Новости и сообщество</div>
  <div class="blocks-container">
    <div v-for="(block, index) in blocks" :key="index" class="content-block">
      <a :href="block.href" target="_blank">
        <div class="block-header">
          <div class="block-icon" :class="block.key"></div>
          <h3 class="block-title">{{ block.title }}</h3>
        </div>
          <p class="block-text">{{ block.text }}</p>
      </a>
    </div>
  </div>
</template>
<script>

export default {
  setup() {
    const blocks = [
      {
        title: 'Вконтакте',
        text: 'Сообщество для HR и руководителей. Делимся лучшими практиками, новостями и историями о развитии эмоционального интеллекта',
        key: 'vk',
        href: 'https://vk.com/way2wei',
      },
      {
        title: 'Rutube',
        text: 'Записи вебинаров, интервью и разборы инструментов WAY2WEI. Используем платформу и подход ЭИ в работе с командами',
        key: 'rutube',
        href: 'https://rutube.ru/channel/25835599',
      },
      {
        title: 'Telegram',
        text: 'Канал с обновлениями, полезными материалами и идеями для развития сотрудников. Коротко, по делу и с реальными кейсами',
        key: 'telegram',
        href: 'https://t.me/way2wei',
      },
    ];

    return {
      blocks,
    };
  },
};
</script>

<style scoped lang="scss">
.blocks-container {
  display: flex;
  gap: 16px;
  width: 100%;
  flex-wrap: wrap;
  margin-bottom: 50px;
}

.content-block {
  flex: 1;
  min-width: 280px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
}

.block-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.block-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
  text-align: left;
}

.block-text {
  font-size: 14px;
  color: var(--grey-text);
  margin: 0;
  padding-left: calc(20px + 12px);
  text-align: left;
  line-height: 120%;
}

.block-main-header {
  margin-bottom: 20px;
  font-size: 20px;
  text-align: left;
  font-weight: 500;
}

@media (max-width: $tablet-breakpoint) {
  .blocks-container {
    flex-direction: column;
  }
}

@media (max-width: $mobile-breakpoint) {
  .content-block {
    min-width: 100%;
  }

  .block-text {
    padding-left: 0;
  }
}

.block-icon {
  width: 20px;
  height: 15px;
  background-size: contain;
  background-repeat: no-repeat;
}

.vk {
  background-image: url('../../assets/images/icons/vk.svg');
}

.content-block:has(.vk):hover {
  .vk {
      background-image: url('../../assets/images/icons/vk-hover.svg');
    }
}

.telegram {
  background-image: url('../../assets/images/icons/telegram.svg');
}

.content-block:has(.telegram):hover {
  .telegram {
    background-image: url('../../assets/images/icons/telegram-hover.svg');
  }
}

.rutube {
  height: 20px;
  background-image: url('../../assets/images/icons/rutube.svg');
}

.content-block:has(.rutube):hover {
  .rutube {
    background-image: url('../../assets/images/icons/rutube-hover.svg');
  }
}
</style>